module.exports = __webpack_public_path__ + "static/media/bottles.da14049e.png";